import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IEditNotificationPayload {
    settingId: string
    data: any
}

export interface IEditNotificationState {
    status: string
    data: any
    errors: any
}

const initialState: IEditNotificationState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const editNotification = createSlice({
    name: 'event-setting/edit-notification',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IEditNotificationPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const editNotificationActions = editNotification.actions
export default editNotification.reducer
